import { useState } from "react";

export const useDisclosure = (initialState = false) => {
	const [isOpen, setIsOpen] = useState(initialState);

	return [isOpen, () => setIsOpen(true), () => setIsOpen(false)] as const;
};
